import AccessoryView  from './view-accessory-view';
/**
 * defa.views.AccessoryCollectionView
 * A collection view for Accessories.
 * @version 0.1
 */
import CollectionView from 'scripts/poppet/collection-view';

const AccessoryCollectionView = CollectionView.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	childView: AccessoryView,

	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	onChildviewShowAccessory: function( id ){
		this.trigger( 'show:accessory', id);
	},
	
} );

export default AccessoryCollectionView;